
import { defineComponent, reactive, toRefs,onMounted } from "vue";
import { onBeforeRouteUpdate, useRouter } from "vue-router";
import LeftMenu from "@/components/LeftMenu.vue";

export default defineComponent({
  components: {
    LeftMenu
  },
  setup() {
    const router = useRouter();
    const state = reactive({
      menuList:[
        {
          id:'1',
          title:'我的应用',
          path:'/myapp'
        }
      ]
    });
     onBeforeRouteUpdate((to) => {
      if (to.path === "/personalhome") {
        router.push({ path: state.menuList[0].path, query: router.currentRoute.value.query });
      }
    });
    return {
      ...toRefs(state),
    }
  }
});
